import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.productListAd';

const translations = {
    'productListAd': 'Terméklista bannerek',
    'id.title': 'ID',
    'create.title': 'Terméklista banner létrehozása',
    'productListAdCreate': 'Terméklista banner létrehozása',
    'edit.title': 'Terméklista banner szerkesztése',
    'name.title': 'Név',
    'banner_url.title': 'Kivezető URL',
    'type.title': 'Típus',
    'active_from.title': 'Megjelenés -tól',
    'active_to.title': 'Megjelenés -ig',
    'is_active.title': 'Aktív',
    'urls.title': 'URL-ek',
    'url_target.title': 'Megnyitás helye',
    'image_url_desktop.title': 'Kép (Desktop)',
    'image_url_desktop.hint': 'Méret: {size}',
    'image_url_mobile.title': 'Kép (Mobil)',
    'image_url_mobile.hint': 'Méret: {size}',
    'priority.title': 'Sorrend',
    'priority.hint': 'A magasabb értékű productListAd/slider jelenik meg előbb.',
    'newProductListAd': 'Új terméklista banner',
    'productAdListType.banner': 'Banner',
    'productAdListType.product': 'Termék',
    'productAdListUrlsForm.pleasePickPosition': 'Termék',
    'urls.deleteAll': 'Összes törlése',
    'url.title': 'URL',
    'tabs.default': 'Alapadatok',
    'tabs.urls': 'URL-ek',
    'product.title': 'Termék',
    'url.hint.url': 'URL cím (kötelező)',
    'url.hint.position': 'Pozíció (kötelező)',
    'sizeHint': 'Méret: 620 x 960',
    'clientSideError.noUrls': 'Kérjük adjon meg legalább egy URL-t!',
    'clientSideError.badUrls': 'Kérjük ellenőrizze, hogy a URL-ekben minden kötelező mező ki van-e töltve!',
    'url.urlMissing': '',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/ProductListAd/lang/hu.ts